<template>
  <div class="toast toastHtml" v-show="show">
    <p v-html="msg" class="msg"></p>
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      show: true,
      msg: ""
      // time: 3000,
      // countDown: null
    };
  },
  methods: {
    open(m) {
      this.msg = m;
      // this.time = t || this.time
      this.show = true;
      // this.countDown = setTimeout(() => {
      //   this.close()
      // }, this.time)
    },
    close() {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  top: 0;
  right: 20%;
  bottom: 0;
  left: 20%;
  margin: auto;
  min-height: 50px;
  max-width: 60%;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  .msg {
    // display: inline-block;
    // white-space: wrap;
    display: flex;
    flex-direction: column;
    width: max-content;
    // max-width: 200px;
    border-radius: 4px;
    padding: 0 56px;
    // width: auto;
    line-height: 40px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 14px;

    span {
      color: #FFFFFF;
      font-size: 14px;

      i {
        color: #41B48C;
        font-style: normal;
      }
    }
  }
}
</style>

<style lang="less">
.toastHtml {
  position: fixed;
  top: 0;
  right: 20%;
  bottom: 0;
  left: 20%;
  margin: auto;
  height: 50px;
  max-width: 60%;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  z-index: 99999;
  .msg {
    display: inline-block;
    white-space: nowrap;
    border-radius: 4px;
    padding: 0 56px;
    width: auto;
    line-height: 50px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 14px;

    span {
      color: #FFFFFF;
      font-size: 14px;

      i {
        color: #41B48C;
        font-style: normal;
      }
    }
  }
}
</style>
